import request from "@/utils/request";

// 列表(主数据列表)
export function loadInvoiceItemListDataApi(data) {
  return request({
    url: "web/invoiceItemSetting/listData",
    method: "post",
    data
  });
}
// 导出
export function loadInvoiceItemExportDataApi(data) {
  return request({
    url: "web/invoiceItemSetting/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateInvoiceItemApi(data) {
  return request({
    url: "web/invoiceItemSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initInvoiceItemApi(data) {
  return request({
    url: "web/invoiceItemSetting/init",
    method: "post",
    data
  });
}

// 下拉
export function getInvoiceItemListApi(data) {
  return request({
      url: "web/invoiceItemSetting/listSelectData",
      method: "post",
      data
  });
}